import { useMemo } from 'react';

import { useMessages } from '../../../hooks/useMessages';
import { type getSmartResizeFollowUpScope } from './getSmartResizeFollowUpScope';
import { selectTailSmartResizeFollowUpScope } from './selectTailSmartResizeFollowUpScope';

/** Scope of the last smart-resize run while it remains the conversation's tail; drives the in-chat follow-up card and the closed-chat popup. */
export const useLatestSmartResizeFollowUpScope = (): ReturnType<typeof getSmartResizeFollowUpScope> => {
  const { messages } = useMessages();

  return useMemo(() => selectTailSmartResizeFollowUpScope(messages), [messages]);
};
